import { BREAKPOINTS } from '@skyscanner/backpack-web/bpk-component-breakpoint';

import type { UserContext } from '@shared/types/user-context';

/**
 * Determines whether a media query should match during SSR based on device type.
 * This ensures the initial server-rendered content matches the expected device viewport.
 *
 * @param {string} query - Media query string or BREAKPOINTS constant
 * @param {UserContext} userContext - User context containing device information
 * @returns {boolean} Whether the media query should match for SSR
 */
export const getMatchSSR = (
  query: string,
  userContext: UserContext,
): boolean => {
  switch (query) {
    case BREAKPOINTS.MOBILE:
      return !!userContext.device.isMobilePhone;
    case BREAKPOINTS.TABLET:
      return !!userContext.device.isTablet;
    case BREAKPOINTS.ABOVE_MOBILE:
      return !userContext.device.isMobilePhone;
    case BREAKPOINTS.ABOVE_TABLET:
      return !!userContext.device.isBrowser;
    default:
      return false;
  }
};
